"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Utilities_1 = require("../../Utilities");
var DetailsColumn_base_1 = require("./DetailsColumn.base");
var DetailsColumn_styles_1 = require("./DetailsColumn.styles");
exports.DetailsColumn = Utilities_1.styled(DetailsColumn_base_1.DetailsColumnBase, DetailsColumn_styles_1.getStyles, undefined, { scope: 'DetailsColumn' });
//# sourceMappingURL=DetailsColumn.js.map


//////////////////
// WEBPACK FOOTER
// ./~/office-ui-fabric-react/lib-commonjs/components/DetailsList/DetailsColumn.js
// module id = 902
// module chunks = 0